"use strict";

Fotobook.preview = {};
